var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Question_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2.001,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#C8DDF5",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 1.001,
    width: 66,
    height: 66,
    rx: 33,
    stroke: "#FCFCFC",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M45.167 42.574h-5.333L33.9 46.521c-.88.587-2.066-.04-2.066-1.107v-2.84c-4 0-6.667-2.666-6.667-6.666v-8c0-4 2.667-6.667 6.667-6.667h13.333c4 0 6.667 2.667 6.667 6.667v8c0 4-2.667 6.666-6.667 6.666Z",
    fill: "#123862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 34.148c-.546 0-1-.454-1-1v-.28c0-1.547 1.134-2.307 1.56-2.6.494-.334.654-.56.654-.907 0-.667-.547-1.213-1.214-1.213-.666 0-1.213.546-1.213 1.213 0 .547-.453 1-1 1-.547 0-1-.453-1-1a3.215 3.215 0 0 1 3.213-3.213 3.215 3.215 0 0 1 3.214 3.213c0 1.52-1.12 2.28-1.534 2.56-.52.347-.68.573-.68.947v.28c0 .56-.453 1-1 1ZM38.5 37.468c-.56 0-1-.454-1-1 0-.547.453-1 1-1 .547 0 1 .453 1 1 0 .546-.44 1-1 1Z",
    fill: "#123862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Question_svg__a",
    x: 0.5,
    y: 0.001,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.818441 0 0 0 0 0.818441 0 0 0 0 0.818441 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7399_136870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7399_136870",
    result: "shape"
  })))));
};
export default SvgQuestion;